import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";

import Home from "./pages/marketing/Home";
import Platform from "./pages/marketing/Platform";
import SentryProduct from "./pages/marketing/SentryProduct";
import ObservatoryProduct from "./pages/marketing/ObservatoryProduct";
import Compliance from "./pages/marketing/Compliance";
import Pricing from "./pages/marketing/Pricing";
import Docs from "./pages/marketing/Docs";
import Blog from "./pages/marketing/Blog";
import BlogPost from "./pages/marketing/BlogPost";
import Contact from "./pages/marketing/Contact";
import AuthPage from "./pages/auth/AuthPage";

import Overview from "./pages/dashboard/Overview";
import Decisions from "./pages/dashboard/Decisions";
import DecisionDetail from "./pages/dashboard/DecisionDetail";
import Policies from "./pages/dashboard/Policies";
import Playground from "./pages/dashboard/Playground";
import Alerts from "./pages/dashboard/Alerts";
import AuditBundles from "./pages/dashboard/AuditBundles";
import Webhooks from "./pages/dashboard/Webhooks";
import Settings from "./pages/dashboard/Settings";
import Drift from "./pages/dashboard/Drift";
import Team from "./pages/dashboard/Team";
import InviteAccept from "./pages/auth/InviteAccept";
import SdkPage from "./pages/marketing/Sdk";

function Protected() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-navy text-cream">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            {/* Marketing */}
            <Route path="/" element={<Home />} />
            <Route path="/platform" element={<Platform />} />
            <Route path="/sentry" element={<SentryProduct />} />
            <Route path="/observatory" element={<ObservatoryProduct />} />
            <Route path="/compliance" element={<Compliance />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/sdk" element={<SdkPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />

            {/* Auth */}
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/invite/:token" element={<InviteAccept />} />

            {/* Dashboard (protected) */}
            <Route element={<Protected />}>
              <Route path="/app" element={<Overview />} />
              <Route path="/app/decisions" element={<Decisions />} />
              <Route path="/app/decisions/:id" element={<DecisionDetail />} />
              <Route path="/app/policies" element={<Policies />} />
              <Route path="/app/playground" element={<Playground />} />
              <Route path="/app/alerts" element={<Alerts />} />
              <Route path="/app/drift" element={<Drift />} />
              <Route path="/app/audit" element={<AuditBundles />} />
              <Route path="/app/webhooks" element={<Webhooks />} />
              <Route path="/app/team" element={<Team />} />
              <Route path="/app/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}
